import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dayOfWeek',

    // WARN: Use with caution!
    // Use this if the pipe should be called on value changed.
    // pure: false,
})
export class DayOfWeekPipe implements PipeTransform {
    private daysWide = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    private daysAbbreviated = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    private daysShort = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    private daysNarrow = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

    public transform(value: number, format: string = 'EEEE'): string {
        if (value < 0 || value > 6) {
            return 'Invalid day number';
        }

        if (['c', 'cc'].includes(format)) {
            return value.toString();
        }

        switch (format) {
            case 'E':
            case 'EE':
            case 'EEE':
            case 'ccc':
                return this.daysAbbreviated[value];
            case 'EEEE':
            case 'cccc':
                return this.daysWide[value];
            case 'EEEEE':
            case 'ccccc':
                return this.daysNarrow[value];
            case 'EEEEEE':
            case 'cccccc':
                return this.daysShort[value];
            default:
                return 'Invalid format';
        }
    }
}
